$(document).ready(function () {
    am4core.ready(function () {

        const zabbixGraphElements = document.querySelectorAll(".zabbixgraph");

        const customBigNumberPrefixes = [
            { "number": 1e+3, "suffix": " <span class='unit'>Kbit/s</span>" },
            { "number": 1e+6, "suffix": " <span class='unit'>Mbit/s</span>" },
            { "number": 1e+9, "suffix": " <span class='unit'>Gbit/s</span>" },
            { "number": 1e+12, "suffix": " <span class='unit'>Tbit/s</span>" },
        ];

        let customNumberFormatter = new am4core.NumberFormatter();
        customNumberFormatter.numberFormat = "#.00a";
        customNumberFormatter.bigNumberPrefixes = customBigNumberPrefixes;

        let observer;

        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 0
        };

        observer = new IntersectionObserver(handleIntersect, options);

        for (const zabbixGraphElement of zabbixGraphElements) {
            observer.observe(zabbixGraphElement);
        }

        function handleIntersect(entries, observer) {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    initializeTrafficGraph(entry.target);
                    observer.unobserve(entry.target);
                }
            }
        }

        function initializeTrafficGraph(graphElement) {
            graphElement.classList.add("loading");

            const configElement = graphElement.querySelector(".zabbixgraph__config");
            const trafficUrl = configElement.dataset.trafficUrl;

            const timeFrame = configElement.dataset.timeFrame;
            const colorLine = getComputedStyle(configElement.querySelector(".zabbixgraph__color-line")).color;
            const colorFill = getComputedStyle(configElement.querySelector(".zabbixgraph__color-fill")).color;

            const bigNumberPrefixes = [
                { "number": 1e+3, "suffix": " Kbit/s" },
                { "number": 1e+6, "suffix": " Mbit/s" },
                { "number": 1e+9, "suffix": " Gbit/s" },
                { "number": 1e+12, "suffix": " Tbit/s" },
            ];

            const chartDiv = graphElement.querySelector(".zabbixgraph__chartdiv");
            let chart = am4core.create(chartDiv.id, am4charts.XYChart);
            chart.dateFormatter.utc = true;
            //chart.dateFormatter.timezone = "Europe/Berlin";
            chart.numberFormatter.numberFormat = "#.a";
            chart.numberFormatter.bigNumberPrefixes = bigNumberPrefixes;

            let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.tooltipDateFormat = "HH:mm, d MMMM yyyy zzz";
            dateAxis.groupData = true;

            switch (timeFrame) {
            case "2 days":
                dateAxis.groupIntervals.setAll([
                    { timeUnit: "minute", count: 10 }
                ]);
                break;
            case "1 month":
                dateAxis.groupIntervals.setAll([
                    { timeUnit: "hour", count: 1 }
                ]);
                break;
            case "3 months":
            case "6 months":
            case "9 months":
            case "1 year":
            case "2 years":
                dateAxis.groupIntervals.setAll([
                    { timeUnit: "day", count: 1 }
                ]);
                break;
            case "3 years":
            case "4 years":
            case "5 years":
                dateAxis.groupIntervals.setAll([
                    { timeUnit: "week", count: 1 }
                ]);
                break;
            default:
                dateAxis.groupIntervals.setAll([
                    { timeUnit: "hour", count: 1 }
                ]);
                break;
            }

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.numberFormatter.numberFormat = "#.#a";
            // Start y axis at 0
            valueAxis.min = 0;

            let series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.dateX = "clock";
            series.dataFields.valueY = "value";
            series.groupFields.valueY = "high";
            series.tooltipText = "{valueY}";
            series.stroke = am4core.color(colorLine);
            series.fill = am4core.color(colorFill);
            series.fillOpacity = 1;
            series.tensionX = 0.8;
            series.tensionY = 0.8;
            series.minBulletDistance = 15;
            series.tooltip.numberFormatter = new am4core.NumberFormatter();
            series.tooltip.numberFormatter.numberFormat = "#.00a";
            series.tooltip.numberFormatter.bigNumberPrefixes = bigNumberPrefixes;

            const bullet = series.bullets.push(new am4charts.CircleBullet());
            const bulletHover = bullet.states.create("hover");
            bulletHover.properties.scale = 1.3;

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.lineY.opacity = 0;
            chart.cursor.behavior = "none";

            const request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState !== XMLHttpRequest.DONE) {
                    return;
                }

                if (request.status !== 200) {
                    const modal = chart.openModal("This chart is currently not available.", "Error loading data");
                    modal.closable = false;
                    graphElement.classList.remove("loading");
                    return;
                }

                let response;
                try {
                    response = JSON.parse(request.responseText);
                } catch (error) {
                    const modal = chart.openModal("This chart is currently not available.", "Error loading data");
                    modal.closable = false;
                    graphElement.classList.remove("loading");
                    return;
                }
                const trafficData = normalizeTrafficData(response);
                const metaData = normalizeMetaData(response);

                chart.data = trafficData;
                updateMeta(graphElement, trafficData, metaData);
                graphElement.classList.remove("loading");
            };

            request.onerror = function () {
                const modal = chart.openModal("This chart is currently not available.", "Error loading data");
                modal.closable = false;
                graphElement.classList.remove("loading");
            };

            request.open("GET", trafficUrl);
            request.send();
        }

        function normalizeTrafficData(response) {
            if (Array.isArray(response)) {
                return aggregateSameAsns(response);
            }

            if (response && Array.isArray(response.traffic)) {
                return aggregateSameAsns(response.traffic);
            }

            return [];
        }

        function normalizeMetaData(response) {
            if (response && response.meta) {
                return response.meta;
            }

            return {};
        }

        function aggregateSameAsns(trafficData) {
            const hasAsn = trafficData.some(function (entry) {
                return entry && typeof entry === "object" && Object.prototype.hasOwnProperty.call(entry, "asn");
            });

            if (!hasAsn) {
                return trafficData;
            }

            const aggregate = {};

            for (const entry of trafficData) {
                if (!entry || typeof entry !== "object") {
                    continue;
                }

                const asn = entry.asn;
                const clock = entry.clock;
                const value = Number(entry.value || 0);
                const key = clock + ":" + asn;

                if (!Object.prototype.hasOwnProperty.call(aggregate, key)) {
                    aggregate[key] = {
                        clock: clock,
                        value: 0
                    };
                }

                aggregate[key].value += value;
            }

            return Object.keys(aggregate).map(function (key) {
                return aggregate[key];
            });
        }

        function updateMeta(graphElement, trafficData, metaData) {
            const allTimePeak = metaData["all-time-peak"];
            const graphPeak = metaData["graph-peak"] !== undefined && metaData["graph-peak"] !== null ? metaData["graph-peak"] : calculatePeak(trafficData);
            const graphAverage = metaData["graph-average"] !== undefined && metaData["graph-average"] !== null ? metaData["graph-average"] : calculateMedian(trafficData);
            const currentValue = metaData.current;

            setMetaValue(graphElement, ".zabbixgraph__meta-peak > .zabbixgraph__meta-content", allTimePeak);
            setMetaValue(graphElement, ".zabbixgraph__meta-max > .zabbixgraph__meta-content", graphPeak);
            setMetaValue(graphElement, ".zabbixgraph__meta-average > .zabbixgraph__meta-content", graphAverage);
            setMetaValue(graphElement, ".zabbixgraph__meta-current > .zabbixgraph__meta-content", currentValue);
        }

        function setMetaValue(graphElement, selector, value) {
            const element = graphElement.querySelector(selector);

            if (element && value !== undefined && value !== null) {
                element.innerHTML = customNumberFormatter.format(value);
            }
        }

        function calculatePeak(trafficData) {
            const values = trafficData.map(function (object) {
                return object.value;
            });

            if (!values.length) {
                return null;
            }

            return values.reduce(function (currentPeak, value) {
                return value > currentPeak ? value : currentPeak;
            }, values[0]);
        }

        function calculateMedian(trafficData) {
            const values = trafficData.map(function (object) {
                return object.value;
            }).sort(function (a, b) {
                return a - b;
            });

            if (!values.length) {
                return null;
            }

            const middle = Math.ceil(values.length / 2);
            return values.length % 2 === 0 ? (values[middle] + values[middle - 1]) / 2 : values[middle - 1];
        }

    });
});
